import { Component, OnInit } from '@angular/core';
import { SportService } from '../services/sport.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-deposit',
  templateUrl: './deposit.component.html',
  styleUrls: ['./deposit.component.scss']
})
export class DepositComponent implements OnInit {
  public Base_Url = environment['adminServerUrl'];
  payDetails: any;
  userDetails: any;
  selectData: any;
  payLength: any;
  referenceNo: any;
  paymentMethodId: any;
  payMethodList: any;
  img_size:any;
  amount: any;
  transsactionList:any
  setValue:any=false
  openEndDate: Date = new Date()
  todayDate: Date = new Date()
  todayDateTime: Date = new Date()
  startdateTime = new Date();
  enddateTime = new Date();
  constructor(private sportService: SportService,private toastr: ToastrService) {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
   }

  ngOnInit(): void {
    this.depositMethod();
    this.getTransactionList()

    this.todayDateTime.setHours(23, 59, 59);
    this.startdateTime.setHours(0, 0, 0, 0);
    this.enddateTime.setHours(23, 59, 59);
  }

  depositMethod() {
    let data = {
      user_id: this.userDetails._id,
      parent_id: this.userDetails.parent_id,
      //domain_id: this.userDetails.domain_id,
      //type: 'DEPOSIT'
    };

    this.sportService.paymentMethodList(data).subscribe((res) => {
      if (res.status == true) {
        this.payMethodList = res.data;
       
        if(this.payMethodList != undefined){
          this.selectData=this.payMethodList[0];
          this.detail(this.payMethodList[0])
        }
      } else {
        this.toastr.error(res.msg)
      }
    })
  }

  getTransactionList() {
    let data = {
         "user_id": this.userDetails._id,
          "statement_type": "1",
          "from_date": this.startdateTime.toISOString(),
          "to_date": this.enddateTime.toISOString()
    };

    this.sportService.getTransaction(data,"wallet/transaction-statement").subscribe((res) => {
      console.log(res)
      if (res.status == true) {
        this.transsactionList = res?.data[0]?.data;
        console.log( this.transsactionList)
      
      } else {
        this.toastr.error(res.msg)
      }
    })
  }

  contentCopied(event){

  }
  AmountSet(){
    if(!this.amount)
      {
        this.toastr.error('amount is required...');
        return;
      }

      this.setValue=true;
  }
  detail(list) {
    this.payDetails = list;
    
  }
  file: File = null;
  imageSrc: any;

  processFile(imageInput: any) { 
    this.file = imageInput.files[0];
    let a = imageInput.files[0];
    let size:any=(a.size/1000000);
    this.img_size=parseFloat(size).toFixed(2);
    console.warn(this.img_size,'MB');
    const reader = new FileReader();
    reader.onload = (e: any) => this.imageSrc = reader.result;
    reader.readAsDataURL(a);
  }

  paymentDeposit() {
    if ((this.payDetails)?.length != 0 || this.payDetails != undefined) {
     
      if (!this.referenceNo) {
          this.toastr.error('referenceNo  is  required...')
        }
     else if (this.selectData?._id != undefined) {
        if(this.amount < this.selectData?.min_amount) {
          this.toastr.error('Minimum deposit amount is  .'+this.selectData?.min_amount)
        }
       else if (this.amount <= this.selectData?.max_amount) {
          if(this.img_size>5.00)
          {
            this.toastr.error('Oops! The size limit for images is below 5.0 MB. Plz select img below 5MB and try again.');
            return;
          }
          if (!this.file) {
             this.toastr.error('Oops! Screenshot is madatory.');
            return;
            }
          const formData: FormData = new FormData();
          formData.append('image', this.file);
          formData.append('user_id', this.userDetails._id);
          formData.append('user_name',  this.userDetails?.user_name);
          formData.append('method_id', this.selectData?._id);
          formData.append('amount', this.amount);
         
          formData.append('sender_name',  'diamond');
          formData.append('receiver_name',  'diamond');
    
          formData.append('reference_no',  this.referenceNo);
          formData.append('promotion_id',  '-1');
       

          this.sportService.paymentDeposit(formData).subscribe((res) => {
            if (res.status) {
              this.toastr.success(res.msg);
              this.payDetails=null;
              this.amount="";
              this.setValue=false;
              this.getTransactionList()
              this.referenceNo="";
              this.file = undefined;
            } else {
              this.toastr.error(res.msg)
            }
          })
        } else {
          this.toastr.error('Maximum deposit amount is  .'+this.selectData?.max_amount)
        }
      } else {
        this.toastr.error('Plz select any payment mode...')
      }
    } else {
      this.toastr.error('Plz select any Payment method')
    }
  }

  close() {
    this.file = undefined;
    this.imageSrc = '';
  }

   copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {
      alert('Text copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy text: ', err);
    });
  }

}
